export default "__VITE_ASSET__CeESm80X__"